<!--
component: TenkeyPad
author: Ken Nakamura
description: テンキーパッド
-->
<template>
  <div class="key-pad flex-container">
    <span class="num-btn" @click="push(7)">7</span>
    <span class="num-btn" @click="push(8)">8</span>
    <span class="num-btn" @click="push(9)">9</span>
    <span class="num-btn" @click="push(4)">4</span>
    <span class="num-btn" @click="push(5)">5</span>
    <span class="num-btn" @click="push(6)">6</span>
    <span class="num-btn" @click="push(1)">1</span>
    <span class="num-btn" @click="push(2)">2</span>
    <span class="num-btn" @click="push(3)">3</span>
    <span class="num-btn" @click="push(0)">0</span>
    <span class="num-btn clear-btn" @click="clear">クリア</span>
  </div>
</template>

<script>
export default {
  name: 'TenkeyPad',
  data: () => {
    return {
      val: 0,
    }
  },
  props: {
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    isSmall() {
      return this.size == 'small';
    }
  },
  methods: {
    /**
     * 数字キーが押された時の処理
     * @param {Number} n 押されたキーの数値
     */
    push (n) {
        this.val = this.val * 10 + n;
        this.$emit('pushed', n);
    },
    /**
     * 入力された数値をクリアする
     */
    clear () {
        this.val = 0;
        this.$emit('clear');
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap;
}
.key-pad {
  background-color: #99bbaa;
  user-select: none;
  width: 290px;
  height: 310px;
  padding: 10px 10px;
  font-size: 14pt;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2),
  0 25px 50px 0 rgba(0, 0, 0, 0.1);
}
.key-pad-large {
  width: 314px;
  height: 385px;
  font-size: 16pt;
}
.key-pad-small {
  width: 250px;
  height: 280px;
  padding: 7px 7px;
  font-size: 12pt;
}
.num-btn {
  //background-color: #ddddcc;
  background-color: #c1ebe9;
  color: #334455;
  text-align: center;
  font-size: 1.8em;
  padding: 0.30em 0.98em;
  margin: 1px 1px;
  cursor: pointer;
  box-shadow: 1px 1px 2px rgba(0, 0, 200, 0.4);
  user-select: none;
}
.clear-btn {
  //font-size: 2.44em; //2.77em;
  //padding:16px 30px 7px;
  padding: 0.30em 1.11em;
}
.num-btn:hover {
    background-color: aquamarine;
}
.num-btn:active {
    background-color: darkcyan;
    color: cornsilk;
    box-shadow: 1px 1px 2px white;
}
</style>